module.exports = __webpack_public_path__ + "static/media/48390309_2309077282500783_6729896389108563968_o.8e37de2f.jpg";